export default function About() {
  return (
    <section id="about" className="py-20 md:py-32 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">クッキングスタジオについて</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-pink-400 to-orange-400 mx-auto"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center max-w-[1000px] mx-auto">
          <div className="w-full lg:w-1/2">
            <img 
              src="https://public.readdy.ai/ai/img_res/8c9b2193b46691087061edd4f684ad47.jpg"
              alt="クッキングスタジオの様子"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-xl"
            />
          </div>
          <div className="w-full lg:w-1/2 space-y-6">
            <h3 className="text-2xl font-bold text-gray-800">私たちのコンセプト</h3>
            <p className="text-gray-600 leading-relaxed">
              「料理を通じて、人生をもっと豊かに」をコンセプトに、初心者からプロを目指す方まで、すべての方に料理の楽しさと奥深さをお伝えしています。
            </p>
            <p className="text-gray-600 leading-relaxed">
              料理は単なる技術ではなく、創造性や感性を育み、人と人をつなぐコミュニケーションツールです。私たちは、一人ひとりの「作りたい」「学びたい」という想いを大切にしながら、丁寧にサポートいたします。
            </p>
            <div className="flex items-start gap-4 pt-4">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full flex-shrink-0">
                <i className="ri-heart-3-fill text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-800 mb-2">心を込めた料理を</h4>
                <p className="text-sm text-gray-600">食材への感謝と、食べる人への思いやりを大切にした料理作りを学びます。</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 max-w-[1000px] mx-auto">
          <div className="bg-gradient-to-br from-pink-50 to-orange-50 rounded-2xl p-8 md:p-12">
            <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">料理教室のシステム</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full mb-4">
                  <i className="ri-group-line text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">少人数制クラス</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  1クラス最大8名までの少人数制。講師が一人ひとりの進度に合わせて丁寧に指導します。質問もしやすく、アットホームな雰囲気で学べます。
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full mb-4">
                  <i className="ri-calendar-check-line text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">フレキシブルな予約制</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  ご都合に合わせて自由にレッスン日を選択できます。平日・週末、昼・夜のクラスをご用意。忙しい方でも無理なく通えます。
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full mb-4">
                  <i className="ri-book-open-line text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">オリジナルレシピ提供</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  すべてのレッスンで詳しいレシピをお渡しします。写真付きで分かりやすく、ご自宅でも復習できます。レシピは専用アプリでも閲覧可能です。
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full mb-4">
                  <i className="ri-medal-line text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">プロ講師による指導</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  レストランやホテルでの実務経験豊富な講師陣が指導。基礎から応用まで、プロの技術とコツを分かりやすくお伝えします。
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full mb-4">
                  <i className="ri-hand-heart-line text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">実習中心のレッスン</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  見るだけでなく、実際に手を動かして学ぶスタイル。一人一台の調理台で、すべての工程を体験できます。作った料理はその場で試食できます。
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-100 to-orange-100 rounded-full mb-4">
                  <i className="ri-customer-service-2-line text-2xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-3">充実のサポート体制</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  レッスン後の質問もLINEやメールで対応。料理に関する疑問や相談にいつでもお答えします。コミュニティで受講生同士の交流も活発です。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
